export type AuditEvent = {
  id: string;
  timestamp: string; // ISO
  module: string; // e.g. 'ecritures','journaux','tiers','rapprochement','etats','learning','certificats'
  action: string; // e.g. 'create','update','delete','import','export','config_save'
  details?: Record<string, any>;
};

const STORAGE_KEY = 'comptaEBNL_audit_log';

export function logAuditEvent(evt: Omit<AuditEvent, 'id' | 'timestamp'> & { details?: Record<string, any> }) {
  const event: AuditEvent = {
    id: `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    timestamp: new Date().toISOString(),
    module: evt.module,
    action: evt.action,
    details: evt.details || {},
  };
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const list: AuditEvent[] = raw ? JSON.parse(raw) : [];
    list.unshift(event);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  } catch {}
}

export function getAuditEvents(): AuditEvent[] {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

export function replaceAuditEvents(events: AuditEvent[]) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(events)); } catch {}
}

export function clearAudit() {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
}